import { ConfirmationDialog, type FireCMSContext } from "@firecms/core";
import { useCallback, useState } from "react";

type OpenConfirmTextActionParams = {
  key: string;
  title: string;
  body: string;
  onConfirm: () => Promise<boolean>;
};

function ConfirmTextActionDialog({
  open,
  closeDialog,
  title,
  body,
  onConfirm,
}: {
  open: boolean;
  closeDialog: () => void;
  title: string;
  body: string;
  onConfirm: () => Promise<boolean>;
}) {
  const [loading, setLoading] = useState(false);

  const handleAccept = useCallback(() => {
    setLoading(true);
    void onConfirm().finally(() => {
      setLoading(false);
      closeDialog();
    });
  }, [closeDialog, onConfirm]);

  return (
    <ConfirmationDialog
      open={open}
      loading={loading}
      title={title}
      body={body}
      onCancel={closeDialog}
      onAccept={handleAccept}
    />
  );
}

export function openConfirmTextAction(
  context: FireCMSContext,
  { key, title, body, onConfirm }: OpenConfirmTextActionParams
): void {
  context.dialogsController.open({
    key,
    Component: ({ open, closeDialog }) => (
      <ConfirmTextActionDialog
        open={open}
        closeDialog={closeDialog}
        title={title}
        body={body}
        onConfirm={onConfirm}
      />
    ),
  });
}
